import { render, staticRenderFns } from "./platforms.vue?vue&type=template&id=14d0492a&scoped=true"
import script from "./platforms.vue?vue&type=script&lang=js"
export * from "./platforms.vue?vue&type=script&lang=js"
import style0 from "./platforms.vue?vue&type=style&index=0&id=14d0492a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d0492a",
  null
  
)

export default component.exports